module.exports = __webpack_public_path__ + "static/media/icon_close.7cf33547.svg";